import { useLocation, useNavigate } from 'react-router-dom'
import CustomerSchedule from 'components/CustomerSchedule'
import OnlinePaymentService from 'services/OnlinePayment'
import CutileiLogo from 'icons/logo-cutilei-simple.png'
import * as FA from 'react-icons/fa'

import {
  Container,
  SubContainer,
  FormField,
  LogoRow,
  SmallImage,
  Form,
  SummaryCard,
  SummaryRow,
  SummaryLabel,
  MoneyTextMask,
  Title,
  SubTitle,
  InfoText,
  Button,
  LinkButton
} from '../styles'

export default function Confirmed () {
  const location = useLocation ()
  const navigate = useNavigate ()
  const schedules = location.state?.schedules
  /*
    Só existe quando o cliente adiantou o sinal. Quem pulou o passo, ou agendou num salão
    que não aceita pagamento online, vê exatamente a tela de antes.
  */
  const payment = location.state?.payment
  const schedulesLink = `${window.location.origin}/customers/${schedules[0].customer.id}/schedules`
  const whatsappMessage = encodeURIComponent (
    `Este é o seu link para acessar seus agendamentos feitos online: ${schedulesLink}`
  )
  const whatsappUrl = `https://api.whatsapp.com/send?phone=55${schedules[0].customer.phone}&text=${whatsappMessage}`

  const createNewSchedule = () => {
    navigate (`/businesses/${schedules[0].business.id}/schedule`, {
      state: { customer: schedules[0]?.customer },
      replace: true
    })
  }

  const goToSchedules = () => {
    navigate (`/customers/${schedules[0].customer.id}/schedules`, { replace: true })
  }

  return (
    <Container style={{padding: 5}}>
      <SubContainer>
        <Form style={{boxShadow: 'none', backgroundColor: '#FFFFFF'}}>
          <LogoRow>
            <SmallImage src={CutileiLogo} alt='Cutilei'/>
            <Title style={{margin: 0}}>Cutilei</Title>
          </LogoRow>
          <Title style={{color: '#44CF6C', marginBottom: 12}}>
            Agendado com sucesso!
          </Title>
          {payment && (
            <SummaryCard style={{marginBottom: 15}}>
              <SummaryRow>
                <SubTitle style={{color: '#44CF6C', display: 'flex', gap: 6}}>
                  <FA.FaCheckCircle size={15} color='#44CF6C' style={{marginTop: 2}}/>
                  Sinal pago
                </SubTitle>
                <MoneyTextMask value={payment.value}/>
              </SummaryRow>
              <SummaryRow>
                <SummaryLabel>Forma de pagamento</SummaryLabel>
                <SummaryLabel style={{color: '#252525'}}>
                  {OnlinePaymentService.getMethodLabel (payment.method)}
                </SummaryLabel>
              </SummaryRow>
              <SummaryRow>
                <SummaryLabel>Restante a pagar no salão</SummaryLabel>
                <MoneyTextMask
                  value={OnlinePaymentService.getTotalValue (schedules) - payment.value}
                />
              </SummaryRow>
            </SummaryCard>
          )}
          <InfoText>
            Confira os detalhes do seu agendamento:
          </InfoText>
          <FormField style={{gap: 15, marginBlock: 15}}>
            {schedules.map ((schedule, index) => (
              <CustomerSchedule
                key={index}
                data={schedule}
                containerStyle={{width: '100%'}}
              />
            ))}
          </FormField>
          <InfoText>
            Você pode fazer um novo agendamento neste mesmo salão ou conferir os seus agendamentos futuros abaixo
          </InfoText>
          <SubContainer style={{marginTop: 15, gap: 10}}>
            <Button onClick={createNewSchedule} style={{width: 240}}>
              Marcar outro agendamento
            </Button>
            <Button onClick={goToSchedules} style={{width: 240}}>
              Ver meus agendamentos
            </Button>
            <LinkButton href={whatsappUrl} target='_blank' style={{width: 240}}>
              <FA.FaWhatsapp size={18} color='#44CF6C'/>
              Enviar para meu WhatsApp
            </LinkButton>
          </SubContainer>
        </Form>
      </SubContainer>
    </Container>
  )
}
